export enum RequiredAggregatedEntityRelations {
  TaskStatus = 'taskStatus',
  TaskPriority = 'taskPriority',
  ResponsibleDepartment = 'responsibleDepartment',
  Department = 'department',
  MembershipLevel = 'membershipLevel',
  GroupStatus = 'groupStatus',
  Location = 'location',
  ProfileType = 'profileType',
  GuestStatus = 'guestStatus',
  TaskType = 'taskType',
  TaskTag = 'taskTag'
}

export enum RequiredAggregatedSystemDictionaryRelations {
  SupportedUiLanguage = 'supportedUiLanguage'
}



// WEBPACK FOOTER //
// ./src/components/TaskManagement/relations/domain/enums.ts